import { render, staticRenderFns } from "./SectionTable.vue?vue&type=template&id=243a069d"
import script from "./SectionTable.vue?vue&type=script&lang=ts"
export * from "./SectionTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('243a069d')) {
      api.createRecord('243a069d', component.options)
    } else {
      api.reload('243a069d', component.options)
    }
    module.hot.accept("./SectionTable.vue?vue&type=template&id=243a069d", function () {
      api.rerender('243a069d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/Info/SectionTable.vue"
export default component.exports